<template>
	<el-dialog  :visible.sync="showresPopup" width="678px" :show-close="false" @close = "closeres">
		<div class="order_res_info">
			<div class="order_res_info_title">
				<div v-if="order_status == 1"><img :src="require(`../assets/imgs/icon/pay_fail.png`)" />等待支付</div>
				<div v-else><img :src="require(`../assets/imgs/icon/pay_success.png`)" />支付成功</div>
			</div>
			<div class="order_res_info_tips">
				订单内容
			</div>
			<div class="order_res_info_info">
				<div class="order_info_item">
					<div class="info_item_left">订单编号</div>
					<div class="info_item_right">{{order_num}}</div>
				</div>
				<div class="order_info_item">
					<div class="info_item_left">订单金额</div>
					<div class="info_item_right">
						<div v-if="buy_type == 1">68元</div>
						<div v-if="buy_type == 2">288元</div>
						<div v-if="buy_type == 3">78元</div>
						<div v-if="buy_type == 4">308元</div>
					</div>
				</div>
				<div class="order_info_item">
					<div class="info_item_left">订单内容</div>
					<div class="info_item_right">
						<div v-if="buy_type == 1">一席会员(连续包季)</div>
						<div v-if="buy_type == 2">一席会员(连续包年)</div>
						<div v-if="buy_type == 3">一席会员(季度)</div>
						<div v-if="buy_type == 4">一席会员(年度)</div>
					</div>
				</div>
			</div>
			<div class="order_res_info_close">
				<div class="info_close_btn" @click="close_orderinf()">关闭</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import requestApi from '@/service';
import { Dialog } from 'element-ui';
export default {
	components: {
	  [Dialog.name]: Dialog,
	},
	props: {
	  payresPopup: {
	    type: Boolean,
	    default: false,
	  },
	  order_num: {
		  // type: String,
		  default: false,
	  },
	  buy_type: {
		  // type: String,
		  default: false,
	  },
	  order_status:{
		  default: false,
	  },
	  
	},
	data() {
		return {
			showresPopup:false,
		}
	},
	watch: {
		payresPopup(val) {
			this.showresPopup = val
			if(this.showresPopup == false) {
				this.$emit('closeres', false);
			}
		}
	},
	methods:{
		closeres() {
			this.$emit('closeres', false);
		},
		close_orderinf() {
			this.closeres()
			this.showresPopup = false
			this.orderTimer = setTimeout(() => {
				this.$router.go(0)
			},1000)
		},
	}
}
</script>

<style lang="scss">
	.order_res_info {
		padding-top: 34px;
		padding-bottom: 12px;
		.order_res_info_title {
			
			div {
				margin: 0 auto;
				width: 180px;
				display: flex;
				align-items: center;
			}
			img {
				font-size: 0;
				width: 28px;
				height: 28px;
				margin-right: 5px;
			}
			font-weight: 600;
			font-size: 24px;
			line-height: 34px;
			color: #333;
			text-align: center;
			margin-bottom: 6px;
		}
		.order_res_info_tips {
			margin-bottom: 12px;
			font-weight: 500;
			font-size: 20px;
			line-height: 28px;
			color: #333333;
			padding: 0 18px;
		}
		.order_res_info_info {
			background: #F3F3F3;
			padding: 4px 24px 20px 18px;
			.order_info_item {
				display: flex;
				justify-content: space-between;
				font-weight: 500;
				font-size: 24px;
				line-height: 34px;
				color: #333333;
			}
			
		}
		.order_res_info_close {
			display: flex;
			justify-content: space-around;
			margin-top: 9px;
			.info_close_btn {
				width: 92px;
				height: 38px;
				background: #000000;
				font-weight: 600;
				font-size: 20px;
				line-height: 38px;
				color: #FFFFFF;
				text-align: center;
			}
		}
	}
</style>